export const UNDERCOVER_CATEGORIES = [
    'Лёгкие', 'Средние', 'Сложные', 'Фильмы', 'Игры', 'Сериалы', 'Знаменитости', 'Природа и животные',
] as const;

export const CUSTOM_CATEGORY = 'Свои';

export interface UndercoverPair {
    id: string;
    main: string;
    variant: string;
    category?: string;
    custom?: boolean;
    ai?: boolean;
}
